import { Table, Tabs } from 'antd';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import AppService from 'services/AppService';
import ListingPage from './ListingPage';

const { TabPane } = Tabs;

export default function CompanyJobList() {
  const [allRoles, setAllRoles] = useState()
  const [jobList, setJobList] = useState();
  const [internshipList, setInternshipList] = useState()
  const { key } = useParams();
  const [openings, setOpenings] = useState({
    all: 0,
    job: 0,
    internship: 0
  })
  const [page, setPage] = useState(1)

  const columns = [
    {
      title: ()=>(
          <p className='table-column-title'>
                  Title
          </p>
      ),
      dataIndex: 'title',
      key: 'title',
      render:(data, record)=>(
        <p className='table-first-column text-capitalize'>{data} {record?.empType ? `(${record?.empType})` : '' }</p>
      )
    },
    {
      title: ()=>(
        <p className='table-column-title'>
                Location
        </p>
    ),
      dataIndex: 'locations',
      key: 'locations',
      render: (_ ,elm) => (
        <>
          <p className="m-0"> {
            elm?.locations?.map((location, i) =>
              <span> {location} {i < elm?.locations.length - 1 && ","} </span>
            )
          }</p></>
      )
    },
    {
      title:()=>(
        <p className='table-column-title'>
                Action

        </p>
    ),
    key:'Action',
      render:(_,elm)=>(
        <a className='anchor-btn capitalized' href={`/app/home/job-details/${elm?.slug}`} target='_blank' rel="noreferrer"> Apply </a>
      )
    }

  ]

  const getJoblistBycompanyKey = async() => {
    try {
      const {
        allRole, 
        jobRole,
        internshipRole, 
        allRoleOpening,
        jobRoleOpening,
        internshipOpening
      } = await AppService.getJoblistBycompanyKey(key, page);

      setAllRoles(allRole)
      setJobList(jobRole)
      setInternshipList(internshipRole)
      setOpenings({
        all: allRoleOpening,
        job: jobRoleOpening,
        internship: internshipOpening
      })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getJoblistBycompanyKey()
  }, [page])

  useEffect(() => {

    document.querySelector('body').style.backgroundColor = '#fff';

  },[])

  return (
    <div >
      <Tabs centered type='card' tabBarStyle={{color: '#91b0ff', marginBottom: '0'}} onChange={(e) => setPage(1)}>
        <TabPane tab={`All Opening ${openings.all}`} key="1">
            {/* <Table columns={columns} dataSource={allRoles} pagination={false} rowKey={elm => elm._id} /> */}
            <ListingPage roles={allRoles} page={page} setPage={setPage} total={openings.all} />
        </TabPane>
        <TabPane tab={`Jobs ${openings.job}`} key="2">
            {/* <Table columns={columns} dataSource={jobList} pagination={false} rowKey={elm => elm._id} /> */}
            <ListingPage roles={jobList} page={page} setPage={setPage} total={openings.job} />
        </TabPane>
        <TabPane tab={`Internships ${openings.internship}`} key="3">
            {/* <Table columns={columns} dataSource={internshipList} pagination={false} rowKey={elm => elm._id} /> */}
            <ListingPage roles={internshipList} page={page} setPage={setPage} total={openings.internship} />
        </TabPane>
      </Tabs>
    </div>
  )
}
